// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3bH9U","left":"StickyBox_left__30Ajr","right":"StickyBox_right__3BvO6"};